import { render, staticRenderFns } from "./jurisdictionAction.vue?vue&type=template&id=67261199&scoped=true&"
import script from "./jurisdictionAction.vue?vue&type=script&lang=js&"
export * from "./jurisdictionAction.vue?vue&type=script&lang=js&"
import style0 from "./jurisdictionAction.vue?vue&type=style&index=0&id=67261199&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67261199",
  null
  
)

export default component.exports